<section class="app-cit-int">
  <div class="app-cit-int__txt" [appAnimate]="'landing'" [speed]="'fast'" [aos]="0.5" [delay]="'500'">
    <h2 class="app-cit-int__txt__tit" [innerHtml]="intro().title"></h2>
    <p class="app-cit-int__txt__desc" appMobTxtExpander [text]="intro().desc" [onlyMobile]="true"></p>
  </div>
  <img
    class="app-cit-int__img d-none d-md-block"
    [alt]="intro().title"
    [src]="intro().img"
    [appAnimate]="'landing'"
    [speed]="'fast'"
    [aos]="0.5"
    [delay]="'500'"
  />
</section>
